import React from 'react';
import {connect} from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import {robotChecked} from '../store/authActions';

const RobotCheck = ({robot,robotChecked}) => {
  const onCheck = (v) => {
    if(v) robotChecked();
  }

  return (
    <>
      { robot &&
        <>
          <ul className='collection container' >
            <div className='collection-item light-blue lighten-5'>
              Welcome to SciNet Portal!
            </div>
            <div className='collection-item light-blue lighten-5'>
              Please verify you're accessing secure <strong>https</strong> site,<br/>
              and the spelling of scinet.utoronto.ca.
            </div>
            <div className='collection-item light-blue lighten-5'>
              The email address you registered with SciNet is required to access this site.
            </div>
          </ul>
          <div style={{'margin':'50px 0px 50px 0px'}}></div>
          <div className='container col'>
            <ReCAPTCHA sitekey='6LdS1kYaAAAAABcZB2XtrrNeaiTgD2Pqi9sntMB0' onChange={onCheck} />
          </div>
        </>
      }
    </>
  );
};

const mapStoreToProps = state => ({
  robot: state.auth.robot
});

export default connect(mapStoreToProps,{robotChecked})(RobotCheck);
